module.exports = __webpack_public_path__ + "media/social/instagram_link-4b91dfb0.svg";